import {emitOnClick, emitOnBlur, emitOnChange, emitOnKeyPress} from '@cred/react-analytics/hoc'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'
import withLinkClickEvent from '@cred/react-analytics/hoc/withLinkClickEvent'
import navigateOnClick from '@cred/shared/hoc/navigateOnClick'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import {Link} from '@cred/react-link'
import Input from '../input'
import Dropdown from '../dropdown'
import Radio from '../radio'
import MoneyInput from '../money-input'
import AddressSearch from '../address-search'
import {textInput, zipInput, selectCustom, select} from '@cred/react-form-field'

const linkWithAnalytics = navigateOnClick(withLinkClickEvent(emitOnClick(emitGAOnClick(Link)))),
  textInputWithAnalytics = withFieldChangeEvent(emitOnBlur(emitOnKeyPress(textInput))),
  zipInputWithAnalytics = withFieldChangeEvent(emitOnBlur(emitOnKeyPress(zipInput))),
  selectCustomWithAnalytics = emitOnChange(selectCustom),
  selectWithAnalytics = emitOnChange(select),
  dropdownWithAnalytics = withFieldChangeEvent(Dropdown),
  addressSearchWithAnalytics = withFieldChangeEvent(AddressSearch),
  moneyInputWithAnalytics = withFieldChangeEvent(MoneyInput)

export {
	textInputWithAnalytics,
	zipInputWithAnalytics,
  selectWithAnalytics,
  selectCustomWithAnalytics,
	dropdownWithAnalytics as Dropdown,
	Radio,
	linkWithAnalytics as Link,
	Input,
	addressSearchWithAnalytics as AddressSearch,
	moneyInputWithAnalytics as MoneyInput
}
